module.exports = __webpack_public_path__ + "media/images/number_17-abc60b2375a2d9d1637eeed48a7ff880.png";